<template>
  <div class="scroller">
    <div class="list">
      <div class="list__heading">
        <h2>Pages</h2>
        <router-link :to="{ name: 'pages.create', query: {search} }" class="btn btn--primary btn--small">
            NEW PAGE
        </router-link>
      </div>

      <div class="list__filter">
        <input type="text" placeholder="Search by title or body text" v-model="search.search">
        <select name="status" id="status" v-model="search.status">
          <option value="">All statuses</option>
          <option value="published">Published</option>
          <option value="draft">Draft</option>
          <option value="private">Private</option>
        </select>
        <select name="status" id="status" v-model="search.order_by">
          <option value="published_at">Sort by published at</option>
          <option value="title">Sort by title</option>
          <option value="id">Sort by id</option>
        </select>
        <select name="sort_by" id="sort_by" v-model="search.sort_by">
          <option value="asc">Direction ascending</option>
          <option value="desc">Direction descending</option>
        </select>
        <select name="language" id="language" v-model="search.language">
          <option v-for="(globalLanguage, index) in languages" :key="index" :value="globalLanguage.iso">{{ globalLanguage.name }}</option>
        </select>
        <button type="button" @click="searchFilter" class="btn btn--primary btn--small">SEARCH</button>
      </div>

      <Loader v-if="isLoading" />

      <div class="listData" v-for="page in pages.data" :key="page.id" v-else>
        <router-link :to="{ name: 'pages.edit', params: { typeId: $route.params.typeId, id: page.id }, query: {search}}" class="listData__link" @click="setSize()">
          <div class="listData__item">
            <h3 class="listData__heading">{{ page.languages[language].title }}</h3>
            <div class="listData_published">
              <font-awesome-icon :icon="['fal', 'clock']" class="listData__icon"/> {{ formatDate(page.published_at) }}
            </div>
          </div>
        </router-link>
        <button class="listData__delete" @click="deletePage(page)">
          <font-awesome-icon :icon="['fal', 'trash-alt']"/>
        </button>
      </div>
    </div>
    <Pagination :pagination="pages.pagination" :Resource="page" :type="types.GET_ALL_PAGES" :isLoading="types.IS_LOADING_PAGES" :customParams="paginationParams"/>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import Page from '@/model/Page'
import Loader from '@/components/Utils/Loader'
import Pagination from '@/components/Utils/Pagination'
import {loadResource, deleteResource, getDate, search} from '@/helpers/resource'

export default {
  computed: {
    languages () {
      return this.$store.getters[types.LANGUAGES]
    },
    language () {
      return this.$store.getters[types.ACTIVE_LANGUAGE]
    },
    pages () {
      return this.$store.getters[types.ALL_PAGES]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_PAGES]
    },
    types () {
      return types
    },
    page () {
      return Page
    },
    typeIds () {
      if (this.$route.params.typeId === 'all') {
        return []
      } else {
        return [this.$route.params.typeId]
      }
    },
    paginationParams () {
      return {types_id: this.typeIds, all_languages: true, ...this.search}
    }
  },
  data () {
    return {
      searchText: '',
      status: '',
      search: {
        search: '',
        status: '',
        order_by: 'published_at',
        sort_by: 'desc',
        language: ''
      }
    }
  },
  components: {
    Loader, Pagination
  },
  mounted () {
    this.search.language = this.language

    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
    loadResource(Page, types.GET_ALL_PAGES, types.IS_LOADING_PAGES, {types_id: this.typeIds, all_languages: true, ...this.search})
  },
  methods: {
    deletePage (page) {
      deleteResource(types.REMOVE_PAGE, page)
    },
    formatDate (date) {
      return getDate(date)
    },
    searchFilter () {
      this.$router.push({name: 'pages.index', params: { typeId: this.$route.params.typeId }})
      this.$router.push({ query: { ...this.$route.query, search: this.search } })

      this.search.types_id = this.typeIds
      this.search.all_languages = true

      this.$store.dispatch(types.ACTIVE_LANGUAGE, this.search.language)

      search(Page, types.GET_ALL_PAGES, types.IS_LOADING_PAGES, this.search)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/PagesList.vue